import { render, staticRenderFns } from "./Collapser.vue?vue&type=template&id=2fd3ecf6&"
import script from "./Collapser.vue?vue&type=script&lang=js&"
export * from "./Collapser.vue?vue&type=script&lang=js&"
import style0 from "./Collapser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports